<template>
  <v-layout
    align-end
    justify-end
    wrap
  >
    <v-flex xs12>
      <v-layout
        row
        v-if="bookingForm.loading == true"
        
        style="width: 100%"
        justify-end
        align-end
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-layout>
      <v-layout row>
        <v-flex v-if="bookingHasOtherTrip " md-12 xl12 lg12>
          <p>Booking is part of a pair ({{ this.bookingForm.booking.cart.outboundBookingId }}, {{ this.bookingForm.booking.cart.returnBookingId }})</p>
        </v-flex>
        <v-flex md12 xl12 lg12 v-if="cancellationFeeAmount != 0">
          {{ (cancellationFeeAmount/100).toFixed(2) }}
        </v-flex>
      </v-layout>
      <v-layout
        v-if="bookingForm.loading == false"
        style="width: 100%"
        justify="space-between"
        align="center"
      >
        <v-flex shrink>
          <v-layout>
            <v-flex>
              <v-layout row >
                <v-flex
                    shrink
                class="mt-1 mr-1">
                  <v-btn
                      color="#E97145"
                      class="text-none white--text"
                      small
                      @click="close"
                  >
                    Close
                  </v-btn>
                </v-flex>
                <v-flex
                    class="mt-1" pr-2>
                  <v-btn
                      v-if="(!updateMode || updateMode == null) && !backdate"
                      submit
                      class="text-none"
                      dark
                      :small="$vuetify.breakpoint.mdAndUp"
                      :x-small="$vuetify.breakpoint.smAndDown"
                      color="#292929"
                      @click="bookAndCopy"
                  >
                    Book and Copy
                  </v-btn>
                </v-flex>
                <v-flex
                    class="mt-1" pr-2>
                  <v-btn
                      v-if="(!updateMode || updateMode == null) && !backdate && allowReturn && bookingForm.booking.outbound_booking_id == null"
                      submit
                      class="text-none"
                      dark
                      :small="$vuetify.breakpoint.mdAndUp"
                      :x-small="$vuetify.breakpoint.smAndDown"
                      color="#00474F"
                      @click="bookAndReturn"
                  >
                    Book and Return
                  </v-btn>
                </v-flex>
                <v-flex
                    class="mt-1" px-1>
                  <v-btn
                      v-if="(!updateMode || updateMode == null) && !backdate"
                      submit
                      class="text-none"
                      dark
                      :small="$vuetify.breakpoint.mdAndUp"
                      :x-small="$vuetify.breakpoint.smAndDown"
                      color="#8268FC"
                      @click="book"
                  >
                    Make Booking
                  </v-btn>
                  <v-menu
                    v-if="(!updateMode || updateMode == null) && !backdate && unconfirmedBookingsEnabled"
                    top
                    :offset-y="true"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="text-none mx-2"
                        dark
                        :small="$vuetify.breakpoint.mdAndUp"
                        :x-small="$vuetify.breakpoint.smAndDown"
                        color="blue"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Unconfirmed
                      </v-btn>
                    </template>
    
                    <v-list>
                      <v-list-item>
                        <v-btn
                          class="text-none mx-2"
                          dark
                          :small="$vuetify.breakpoint.mdAndUp"
                          :x-small="$vuetify.breakpoint.smAndDown"
                          @click="bookButNotConfirmed('busy')"
                          color="purple lighten-2"
                        >
                          Unconfirmed Booking
                        </v-btn>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                              small
                            >
                              mdi-information
                            </v-icon>
                          </template>
                          <span>
                          Booking can be confirmed later and we are saying that we will contact you once booking is confirmed.
                        </span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-btn
                          class="text-none mx-2"
                          dark
                          :small="$vuetify.breakpoint.mdAndUp"
                          :x-small="$vuetify.breakpoint.smAndDown"
                          @click="bookButNotConfirmed('unavailable')"
                          color="orange"
                        >
                          No Driver Available
                        </v-btn>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                              small
                            >
                              mdi-information
                            </v-icon>
                          </template>
                          <span>
                          Booking can be confirmed later but we are saying we have no availability
                        </span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <UnconfirmedBookingOfferPubliclyCheckBox></UnconfirmedBookingOfferPubliclyCheckBox>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                              small
                            >
                              mdi-information
                            </v-icon>
                          </template>
                          <span>
                          Unconfirmed bookings are on BID by default.
                        </span>
                        </v-tooltip>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-btn
                      v-if="(!updateMode || updateMode == null) && backdate"
                      submit
                      class="text-none"
                      dark
                      color="#8268FC"
                      :small="$vuetify.breakpoint.mdAndUp"
                      :x-small="$vuetify.breakpoint.smAndDown"
                      @click="backdateTrip"
                  >
                    Backdate
                  </v-btn>
                </v-flex>
                <v-flex
                    class="mt-1"
                    v-if="
                bookingForm.booking.state != null &&
                  bookingForm.booking.state != 'cancelled' &&
                  bookingForm.booking.state != 'completed'
              "
                    px-1
                >
                  <v-btn
                      dark
                      color="red lighten-2"
                      class="text-none"
                      :small="$vuetify.breakpoint.mdAndUp"
                      :x-small="$vuetify.breakpoint.smAndDown"
                      @click="showCancel"
                  >
                    Cancel Booking
                  </v-btn>
                </v-flex>
                <v-flex
                    class="mt-1"
                    v-if="bookingForm.booking.state"
                >
                  <v-btn
                      submit
                      dark
                      color="#003A8C"
                      class="text-none mx-1"
                      :small="$vuetify.breakpoint.mdAndUp"
                      :x-small="$vuetify.breakpoint.smAndDown"
                      @click="copyBooking"
                  >
                    Copy Trip
                  </v-btn>
                </v-flex>
                <v-flex
                    class="mt-1"
                    v-if="bookingForm.booking.state && bookingForm.booking.state != 'unconfirmed'"
                >
                  <v-btn
                      submit
                      dark
                      color="#8268FC"
                      class="text-none"
                      :small="$vuetify.breakpoint.mdAndUp"
                      :x-small="$vuetify.breakpoint.smAndDown"
                      @click="update"
                  >
                    Update Trip
                  </v-btn>
                </v-flex>
                <v-flex
                    class="mt-1"
                    v-if="bookingForm.booking.state && bookingForm.booking.state == 'unconfirmed'"
                >
                  <v-btn
                      submit
                      dark
                      color="#8268FC"
                      class="text-none"
                      :small="$vuetify.breakpoint.mdAndUp"
                      :x-small="$vuetify.breakpoint.smAndDown"
                      @click="confirmTrip"
                  >
                    Confirm Trip
                  </v-btn>
                </v-flex>
                <v-flex
                    class="mt-1"
                    v-if="
                largeMode &&
                  bookingForm.booking.state != null &&
                  bookingForm.booking.state != 'accepted'
              "
                    px-1
                >
                  <v-btn
                      dark
                      color="orange"
                      class="text-none"
                      small
                      @click="showChangeUser"
                  >
                    Change User
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <p style="color: red; margin-left: 18px">
        {{ bookingForm.errors.error }}
      </p>
    </v-flex>
    <v-dialog
      v-model="cancelDialog"
      persistent
      width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Cancel Booking</span>
        </v-card-title>
        <v-flex pa-4>
          <v-flex
            shrink
          >
            <v-radio-group v-model="cancellationReason" row>
              <v-radio
                label="I no longer need this trip"
                :value="'I no longer need this trip'"
              />
              <v-radio
                label="My driver asked me to cancel"
                :value="'My driver asked me to cancel'"
              />
              <v-radio
                label="Driver was too far away"
                :value="'Driver was too far away'"
              />
              <v-radio
                label="Driver was too early"
                :value="'Driver was too early'"
              />
              <v-radio
                label="No Driver available"
                :value="'no driver available'"
              />
              <v-radio
                label="Other"
                :value="'other'"
              />
            </v-radio-group>
            <div>
              <v-col md="6">
                <v-textarea
                  v-if="cancellationReason"
                  class="small-text-field"
                  label="Type cancellation reason"
                  placeholder=" "
                  :height="28"
                  flat
                  filled
                  outlined
                  dense
                  v-model="otherCancellationReason"
                />
      
              </v-col>
            </div>
          </v-flex>
          <v-row>
            <v-flex
              v-if="bookingForm.booking.card_payment_type == 'prepaid'"
              shrink
            >
              <v-radio-group v-model="cancellationFee">
                <v-radio
                  label="Use System Policy"
                  :value="0"
                />
                <v-radio
                  label="Yes, Charge Cancellation Fee"
                  :value="1"
                />
                <v-radio
                  label="No, Do NOT Charge Cancellation Fee"
                  :value="2"
                />
              </v-radio-group>
            </v-flex>
            <v-flex
              v-if="bookingForm.booking.card_payment_type != 'prepaid' && bookingForm.booking.payment_type == 'card'"
              shrink
            >
              <p>Cancellation Fee</p>
              <v-radio-group v-model="cancellationFee">
                <v-radio
                  :label="'Use System Policy'"
                  :value="0"
                />
                <v-radio
                  label="Yes, Charge Cancellation Fee"
                  :value="1"
                />
                <v-radio
                  label="No, Do NOT Charge Cancellation Fee"
                  :value="2"
                />
              </v-radio-group>
              <v-currency-field
                v-if="cancellationFee == 1"
                v-model="amount"
                type="number"
                v-bind="currency_config"
                min="0"
                class="small-text-field"
                single-line
                height="28"
                flat
              />
            </v-flex>
            <v-flex
              shrink
              pl-5
            >
              <v-checkbox
                v-if="bookingHasOtherTripToCancel"
                v-model="cancelOtherTrip"
                :label="'Cancel ' + nameForOtherTrip + ' trip'"
              />
            </v-flex>
          </v-row>
        </v-flex>
        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            text
            @click="cancelDialog = false"
          >
            Back
          </v-btn>
          <v-btn
            flat
            text
            @click="cancel"
          >
            Confirm Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import SimpleTextAreaInput from "@/components/widget/input/SimpleTextAreaInput.vue";
import qs from "qs";
import axios from "axios";
import moment from 'moment/moment'
import UnconfirmedBookingOfferPubliclyCheckBox
  from '@/components/booking/unconfirmed/UnconfirmedBookingOfferPubliclyCheckBox'

axios.defaults.withCredentials = true;

export default {
  name: "BookRideOptions",
  components: {
    UnconfirmedBookingOfferPubliclyCheckBox,
    SimpleTextAreaInput
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    allowReturn: Boolean,
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    updateMode: {
      type: Boolean,
      default: false,
    },
    largeMode: {
      type: Boolean,
      default: true,
    },
    backdate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unconfirmedBookingWaitingTimeInHours: 12,
      cancellationReason: "",
      otherCancellationReason: "",
      menu: false,
      cancelDialog: false,
      cancellationFee: false,
      cancelOtherTrip: false,
      amount: null,
      cancellationFeeAmount: 0,
      currency_config: {
        decimal: ".",
        prefix: "£",
        precision: 2,
        masked: false,
        allowBlank: true
      },
    };
  },
  computed: {
    dispatchConfiguration () {
      return this.$store.getters['dispatch/getDispatchConfiguration']
    },
    offerUnconfirmedBookingPublicly () {
      return this.$store.getters['unconfirmedBooking/isOfferPublicly']
    },
    unconfirmedBookingsConfig () {
      return (this.dispatchConfiguration ? this.dispatchConfiguration.unconfirmed_booking_configuration : null)
    },
    unconfirmedBookingsEnabled () {
      return (this.unconfirmedBookingsConfig ? this.unconfirmedBookingsConfig.enabled : false)
    },
    bookingHasOtherTrip: function() {
      if (this.bookingForm.booking.cart != null) {
        return true;
      }

      return false;
    },
    nameForOtherTrip: function () {
      if (
          this.bookingForm.booking.cart.outboundBookingId ==
          this.bookingForm.booking.id
      ) {
        return "Return";
      } else {
        return "Outbound";
      }
    },
    bookingHasOtherTripToCancel: function () {
      if (this.bookingForm.booking.cart == null) {
        return false;
      }

      if (
        this.bookingForm.booking.cart.outboundBookingId ==
        this.bookingForm.booking.id
      ) {
        if (this.bookingForm.booking.cart.returnBookingId != null) {
          if (
            this.bookingForm.booking.cart.returnState != "completed" &&
            this.bookingForm.booking.cart.returnState != "cancelled"
          ) {
            return true;
          }
        }
      } else {
        if (
          this.bookingForm.booking.cart.outboundState != "completed" &&
          this.bookingForm.booking.cart.outboundState != "cancelled"
        ) {
          return true;
        }
      }

      return false;
    },
  },
  methods: {
    isBusinessUserEntered() {
      if (this.bookingForm.booking.business_customer_email != null &&
        this.bookingForm.booking.business_customer_name != null &&
        this.bookingForm.booking.business_customer_reference != null &&
        this.bookingForm.booking.authorized_by != null) {
        return true
      }
      return false
    },
    copyBooking () {
      return window.open('/book?rebook=' + this.bookingForm.booking.id)
    },
    showCancel: async function() {
      this.cancelDialog = true

       try {
        var url = `${this.$store.state.apiUrl}/booking/getCancellationFee/${this.bookingForm.booking.id}`;

        let response = await axios.get(url, {
          params: {}
        });

        console.log(response.data);

        this.cancellationFeeAmount = response.data.cancellationFee
      } catch (error) {
        this.loadingEditBooking = false;

        console.log("Failed to get booking " + error);
        return "Unknown Error";
      }
    },
    showChangeUser: function () {
      this.$emit("change", null);
      console.log("Show change user");
    },
    expand: function () {
      this.$emit("expand", null);
    },
    close: function () {
      window.close()
      this.$emit("close", null);
    },
    bookAndReturn: function () {
      this.$emit("bookAndReturn", null);
    },
    bookAndCopy: function () {
      this.$emit("bookAndCopy", null);
    },
    bookButNotConfirmed: function (availabilityStatus) {
      if (this.bookingForm.booking.payment_type == 'account' && !this.isBusinessUserEntered() ) {
        this.bookingForm.validateBusinessCustomerDetails()
        this.$snackbar.error("Please enter lead passenger details")
        return;
      }
    
      if (availabilityStatus == 'busy' && moment(this.bookingForm.booking.pickup_date + " " + this.bookingForm.booking.pickup_time,
        "YYYY-MM-DD HH:mm").isBefore(moment().add(this.unconfirmedBookingWaitingTimeInHours, 'hours'))) {
        this.$snackbar.error('Pickup time for unconfirmed booking should be after ' + moment().add(this.unconfirmedBookingWaitingTimeInHours,'hours').format('DD-MM-YYYY HH:mm'))
        return false
      }
      if (this.offerUnconfirmedBookingPublicly) {
        this.bookingForm.booking.offer_booking_publically = true
      }
      this.bookingForm.booking.availability_status = availabilityStatus
      this.$emit("bookUnconfirmed", null);
    },
    book: function () {
      if (this.bookingForm.booking.payment_type == 'account' && !this.isBusinessUserEntered() ) {
        this.bookingForm.validateBusinessCustomerDetails()
        this.$snackbar.error("Please enter lead passenger details")
        return;
      }
      this.$emit("book", null);
    },
    backdateTrip: function () {
      this.$emit("backdate", null);
    },
    update: function () {
      this.$emit("update", null);
    },
    confirmTrip: function () {
      if (moment(this.bookingForm.booking.pickup_date + " " + this.bookingForm.booking.pickup_time,
        "YYYY-MM-DD HH:mm").isBefore(moment())) {
        this.$snackbar.error('Pickup time for booking should be 15 minutes or more in the future.')
        return false
      }
      this.$emit("confirmTrip", null);
    },
    cancel: function () {

      if (this.cancellationFee != 1) {
        this.amount = null;
      }

      if (this.cancellationFee == 1 && this.amount == null) {
        alert("Please enter a fee")
        return;
      }
  
  
      if (!this.cancellationReason) {
        this.$snackbar.error("Please select cancellation reason")
        return;
      }
      if (!this.otherCancellationReason) {
        this.$snackbar.error("Please type cancellation reason")
        return;
      }

      this.cancelDialog = false;
      this.$emit("cancel", {
        cancellationFee: this.cancellationFee,
        cancelOtherTrip: this.cancelOtherTrip,
        amount: this.amount,
        cancellationReason: this.cancellationReason,
        otherCancellationReason:this.otherCancellationReason,
      });
    },
    clear: function () {
      this.bookingForm.clear();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
